import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#FAF7F2]">
      <div className="h-px bg-gradient-to-r from-transparent via-[#C4A265] to-transparent"></div>
      
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <div className="flex flex-col sm:flex-row items-start justify-between gap-8">
          {/* Brand */}
          <div className="flex-shrink-0">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_behad-living/artifacts/rxtdz05y_Behat_Atelier.png"
                alt="Behat House Logo"
                className="h-11 w-auto object-contain"
              />
              <div>
                <h3 className="text-lg font-serif text-black">Behat House</h3>
                <p className="text-[10px] text-black tracking-[0.3em] font-semibold uppercase font-serif">Atelier</p>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-[#7A6B5D] max-w-xs mb-4">
              Celebrating India's rich heritage through exquisite handcrafted home decor.
            </p>
            <div className="flex space-x-2.5">
              <a href="https://www.instagram.com/behathouse" target="_blank" rel="noopener noreferrer" className="p-2 border border-[#C4A265]/40 hover:bg-[#C4A265] text-[#C4A265] hover:text-white rounded-full transition-all duration-300">
                <Instagram className="w-3.5 h-3.5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#3E2723] font-semibold mb-4 text-xs tracking-[0.2em] uppercase">Quick Links</h4>
            <ul className="grid grid-cols-2 gap-x-8 gap-y-2.5">
              {[
                { to: '/', label: 'Home' },
                { to: '/shop', label: 'Shop' },
                { to: '/about', label: 'About Us' },
                { to: '/blog', label: 'Blog' },
                { to: '/contact', label: 'Contact' },
                { to: '/shipping-returns', label: 'Shipping & Returns' }
              ].map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-[#7A6B5D] hover:text-[#C4A265] transition-colors duration-300 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-[#E8DCC8] text-center">
          <p className="text-xs text-[#A09486]">
            &copy; {new Date().getFullYear()} Behat House Atelier. Preserving traditions, creating masterpieces.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
